import { BlogDetailComponent } from './blogs/blog-detail/blog-detail.component';
import { BlogsComponent } from './blogs/blogs/blogs.component';
import { ContactComponent } from './contact/contact.component';
import { PrivacySecurityComponent } from './privacy-security/privacy-security.component';
import { DistanceSellingContractComponent } from './distance-selling-contract/distance-selling-contract.component';
import { CancelPaymentComponent } from './cancel-payment/cancel-payment.component';
import { SoftwareServicesComponent } from './software-services/software-services.component';
import { ReferenceProjectsComponent } from './reference-projects/reference-projects.component';
import { ReferenceCompaniesComponent } from './reference-companies/reference-companies.component';
import { PersonelConsultantComponent } from './personel-consultant/personel-consultant.component';
import { CompanyConsultantComponent } from './company-consultant/company-consultant.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { HomeComponent } from './home/home.component';
import { SiteComponent } from './site.component';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CareersComponent } from './careers/careers.component';

const routes: Routes = [
  {
    path: '', component: SiteComponent,
    children:[
      {path:'', component: HomeComponent ,pathMatch:'full',},
      {path: 'home', component: HomeComponent },
      {path: 'about', component: AboutUsComponent },
      {path: 'careers', component: CareersComponent },
      {path: 'company-consultant', component: CompanyConsultantComponent },
      {path: 'contact', component: ContactComponent },
      {path: 'personel-consultant', component: PersonelConsultantComponent },
      {path: 'reference-companies', component: ReferenceCompaniesComponent },
      {path: 'reference-projects', component: ReferenceProjectsComponent },
      {path: 'software-services', component: SoftwareServicesComponent },
      {path: 'cancel-payment', component: CancelPaymentComponent },
      {path: 'distance-selling-contract', component: DistanceSellingContractComponent },
      {path: 'privacy-security', component: PrivacySecurityComponent },
      {path: 'blogs', component: BlogsComponent },
      { path: 'blog/:id', component: BlogDetailComponent },
      { path: 'blog', redirectTo: 'blogs' },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SiteRoutingModule { }
